import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseConversationMentionUnread } from 'entities/Conversation/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { Conversation } from 'entities/Conversation'
import { Inbox } from 'entities/Inbox/model/Inbox'
import { type ConversationMenuStore } from '../store/conversationMenuStore'

export const useConversationMentionUnread = (store: ConversationMenuStore) => {
  const entities = useEntitiesContext()
  const { websocket, inboxesStore } = entities
  const handler = (data: IResponseConversationMentionUnread) => {
    const { inboxesMap } = inboxesStore
    const inbox = inboxesMap.get(data.inbox_id)

    if (inbox instanceof Inbox) inbox.handleUpdateUnreadMentionsCount(data)
    const conversation = new Conversation(data.conversation, entities)

    const conversationMentionCount = Math.abs(
      data.conversation.unread_mentions_count_prev - data.conversation.unread_mentions_count
    )
    const isIncrease =
      data.conversation.unread_mentions_count_prev < data.conversation.unread_mentions_count

    if (conversationMentionCount) {
      store.quickFiltersMenuStore.handleQuickFilterCountByKey({
        key: 'mentions',
        isIncrease,
        decreaseCount: isIncrease ? 0 : conversationMentionCount,
        increaseCount: isIncrease ? conversationMentionCount : 0,
      })

      store.quickFiltersMenuStore.handleQuickFilterCount({
        conversation,
        isIncrease,
        decreaseCount: conversationMentionCount,
      })
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.ConversationMentionUnread, handler), [])
}
